import SignIn from "@views/public/sign-in/sign-in.vue";
import PublicHome from "@views/public/public-home.vue";
import { contractExternalActionsRoutes } from "@/app/router/contract-external-actions/contract-external-actions-routes";
const EmailVerificationView = () => import("@views/public/email-verification/email-verification-view.vue");

const signInRoutes = [
    {
        component: SignIn,
        name: "sign-in",
        path: "sign-in",
    },
];

export const publicRoutes = [
    {
        children: [
            ...signInRoutes,
            ...contractExternalActionsRoutes,
            {
                component: EmailVerificationView,
                name: "EmailVerification",
                path: "email-verify/:id",
                meta:{
                    navigation: { end: "ProcessEndScreen" },
                }
            },
        ],
        component: PublicHome,
        name: "public",
        path: "public",
        redirect: "public/sign-in", // this is the default public view
    },
];